import { AlertTriangle } from "lucide-react";

export const BallotWarning = ({ compact = false, testId = "ballot-secrecy-warning" }) => (
  <div
    role="status"
    data-testid={testId}
    className={`rounded-lg border border-amber-300 bg-amber-50 text-amber-900 flex items-start gap-3 ${
      compact ? "px-3 py-2 text-xs" : "px-4 py-3 text-sm"
    }`}
  >
    <AlertTriangle className={`shrink-0 ${compact ? "h-4 w-4 mt-0.5" : "h-5 w-5 mt-0.5"}`} aria-hidden="true" />
    <p className="font-medium leading-snug">
      Never provide your voting PIN, password, Voter Information Letter, ballot screenshot, ballot
      photograph or voting credentials. <span className="font-bold">NEVER UPLOAD YOUR BALLOT.</span>
    </p>
  </div>
);
